export default "__VITE_ASSET__e6be566e__"